function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 21a9 9 0 009-9c0-4.969-4.03-9-9-9s-9 4.031-9 9a9 9 0 009 9zm.88-7.839h-1.76a.436.436 0 01-.436-.411l-.269-4.936a.436.436 0 01.435-.46h2.3c.25 0 .449.21.435.46l-.27 4.936a.435.435 0 01-.434.411zM12 17.153a1.67 1.67 0 110-3.342 1.67 1.67 0 010 3.343z",
  fill: "#FBBD4A",
  fillRule: "evenodd"
});

function SvgWarninginline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgWarninginline;